import api from './axios.js'

export const getCases = (categorySlug = null) => {
	const url = categorySlug ? `/content/cases/?category=${categorySlug}` : '/content/cases/'
	return api.get(url)
}

export const getCasesCategory = () => {
	return api.get('/content/cases-categories/')
}

